// export const enum UploaderActionKind {
//   ADDPHOTO = "add_photo",
//   UPDATE_CAN_DRAG = "update_can_drag",
//   UPDATE_RESIZED_IMAGE = "update_resized_image",
//   UPDATE_IS_UPLOADED = "update_is_uploaded",
//   UPDATE_RESIZED_PERCENT = "update_resized_percent",
//   REMOVE_PHOTO = "remove_photo",
// }

import { arrayMove } from "@dnd-kit/sortable";

// export const initialState: UploaderState = {
//   canDrag: false,
//   numberOfPhotos: 0,
//   allImagesSrcs: [],
//   photosArray: [],
// };

// export type UploaderDataAction =
//   | {
//       type: UploaderActionKind.ADDPHOTO;
//       newPhoto: PhotoState;
//     }
//   | {
//       type: UploaderActionKind.UPDATE_RESIZED_IMAGE;
//       file: File;
//       localImageSrc: string;
//       resizedImageSrc: string;
//     }
//   | {
//       type: UploaderActionKind.UPDATE_IS_UPLOADED;
//       resizedImageSrc: string;
//       isUploaded: boolean;
//     }
//   | {
//       type: UploaderActionKind.UPDATE_CAN_DRAG;
//       canDrag: boolean;
//     }
//   | {
//       type: UploaderActionKind.UPDATE_RESIZED_PERCENT;
//       localImageSrc: string;
//       resizedPercent: number;
//     }
//   | {
//       type: UploaderActionKind.REMOVE_PHOTO;
//       resizedImageSrc: string;
//     };

// export function uploaderReducer(
//   state: UploaderState,
//   action: UploaderDataAction
// ) {
//   switch (action.type) {
//     case UploaderActionKind.ADDPHOTO: {
//       return {
//         ...state,
//         canDrag: false,
//         allImagesSrcs: [...state.allImagesSrcs, newImageSrc],
//         numberOfPhotos: state.numberOfPhotos + 1,
//         photosArray: [...state.photosArray, action.newPhoto],
//       };
//     }
//     case UploaderActionKind.UPDATE_RESIZED_IMAGE: {
//       const newAllImagesSrcs = state.allImagesSrcs.map((imageSrc) =>
//         imageSrc === action.localImageSrc ? action.resizedImageSrc : imageSrc
//       );
//       return {
//         ...state,
//         allImagesSrcs: newAllImagesSrcs,
//         photosArray: state.photosArray.map((photo) =>
//           photo.localImageSrc === action.localImageSrc
//             ? {
//                 ...photo,
//                 file: action.file,
//                 localImageSrc: undefined,
//                 resizedImageSrc: action.resizedImageSrc,
//               }
//             : photo
//         ),
//       };
//     }
//     case UploaderActionKind.UPDATE_IS_UPLOADED: {
//       return {
//         ...state,
//         photosArray: state.photosArray.map((photo) =>
//           photo.resizedImageSrc === action.resizedImageSrc
//             ? { ...photo, isUploaded: action.isUploaded }
//             : photo
//         ),
//       };
//     }
//     case UploaderActionKind.UPDATE_CAN_DRAG: {
//       return {
//         ...state,
//         canDrag: action.canDrag,
//       };
//     }
//     case UploaderActionKind.UPDATE_RESIZED_PERCENT: {
//       return {
//         ...state,
//         photosArray: state.photosArray.map((photo) =>
//           photo.localImageSrc === action.localImageSrc
//             ? { ...photo, resizedPercent: action.resizedPercent }
//             : photo
//         ),
//       };
//     }
//     case UploaderActionKind.REMOVE_PHOTO: {
//       return {
//         ...state,
//         numberOfPhotos: state.numberOfPhotos - 1,
//         allImagesSrcs: state.allImagesSrcs.filter(
//           (src) => src !== action.resizedImageSrc
//         ),
//         photosArray: state.photosArray.filter(
//           (photo) => photo.resizedImageSrc !== action.resizedImageSrc
//         ),
//       };
//     }
//     default:
//       return state;
//   }
// }

// interface UploaderState {
//   canDrag: boolean;
//   numberOfResizingPhotos: number;
//   numberOfPhotos: number;
//   photosArray: PhotoState[];
// }

// interface PhotoState {
//   file: File;
//   resizedImageSrc: string;
//   isUploaded: boolean;
// }

export const enum UploaderActionKind {
  ADDPHOTO = "add_photo",
  ADDRESIZEDPHOTO = "add_resized_photo",
  UPDATE_CAN_DRAG = "update_can_drag",
  RESET_NUMBER_OF_RESIZING = "reset_number_of_resizing",
  UPDATE_IS_UPLOADED = "update_is_uploaded",
  INCREASE_NUMBER_OF_RESIZING = "update_number_of_resizing",
  INCREASE_NUMBER_OF_PHOTOS = "increase_number_of_photos",
  DECREASE_NUMBER_OF_PHOTOS = "decrease_number_of_photos",
  REMOVE_PHOTO = "remove_photo",
  REORDER_PHOTO = "reorder_photo",
  INIT_SAVED_STATE = "init_saved_state",
  ADD_IMAGE_BACK_ON_POSITION = "add_image_back_on_position",
}

export const initialState: UploaderState = {
  canDrag: false,
  numberOfResizingPhotos: 0,
  numberOfPhotos: 0,
  photosArray: [],
};

export type UploaderDataAction =
  | {
      type: UploaderActionKind.ADDPHOTO;
      newPhoto: PhotoState;
    }
  | {
      type: UploaderActionKind.INIT_SAVED_STATE;
      distributionUrls: string[];
    }
  | {
      type: UploaderActionKind.ADDRESIZEDPHOTO;
      newPhoto: PhotoState;
    }
  | {
      type: UploaderActionKind.UPDATE_IS_UPLOADED;
      resizedImageSrc: string;
      distributionSrc: string;
      isUploaded: boolean;
    }
  | {
      type: UploaderActionKind.UPDATE_CAN_DRAG;
      canDrag: boolean;
    }
  | {
      type: UploaderActionKind.REMOVE_PHOTO;
      resizedImageSrc: string;
    }
  | {
      type: UploaderActionKind.INCREASE_NUMBER_OF_RESIZING;
    }
  | {
      type: UploaderActionKind.RESET_NUMBER_OF_RESIZING;
    }
  | {
      type: UploaderActionKind.REORDER_PHOTO;
      oldIndex: number;
      newIndex: number;
    }
  | {
      type: UploaderActionKind.INCREASE_NUMBER_OF_PHOTOS;
      addedNumber: number;
    }
  | {
      type: UploaderActionKind.DECREASE_NUMBER_OF_PHOTOS;
    }
  | {
      type: UploaderActionKind.ADD_IMAGE_BACK_ON_POSITION;
      index: number;
      photo: PhotoState;
    };

export function uploaderReducer(
  state: UploaderState,
  action: UploaderDataAction
) {
  switch (action.type) {
    case UploaderActionKind.ADDPHOTO: {
      return {
        ...state,
        canDrag: false,
        photosArray: [...state.photosArray, action.newPhoto],
      };
    }
    case UploaderActionKind.INIT_SAVED_STATE: {
      const newPhotosArray = action.distributionUrls.map(
        (url) =>
          <PhotoState>{
            file: EMPTY_FILE_PLACEHOLDER,
            resizedImageSrc: url,
            distributionSrc: url,
            isUploaded: true,
          }
      );
      return {
        ...state,
        numberOfPhotos: newPhotosArray.length,
        canDrag: false,
        photosArray: newPhotosArray,
      };
    }
    case UploaderActionKind.ADDRESIZEDPHOTO: {
      return {
        ...state,
        numberOfResizingPhotos: state.numberOfResizingPhotos - 1,
        canDrag: false,
        photosArray: [...state.photosArray, action.newPhoto],
      };
    }
    case UploaderActionKind.UPDATE_IS_UPLOADED: {
      return {
        ...state,
        photosArray: state.photosArray.map((photo) =>
          photo.resizedImageSrc === action.resizedImageSrc
            ? {
                ...photo,
                isUploaded: action.isUploaded,
                distributionSrc: action.distributionSrc,
              }
            : photo
        ),
      };
    }
    case UploaderActionKind.UPDATE_CAN_DRAG: {
      return {
        ...state,
        canDrag: action.canDrag,
      };
    }
    case UploaderActionKind.REMOVE_PHOTO: {
      return {
        ...state,
        numberOfPhotos: state.numberOfPhotos - 1,
        photosArray: state.photosArray.filter(
          (photo) => photo.resizedImageSrc !== action.resizedImageSrc
        ),
      };
    }
    case UploaderActionKind.INCREASE_NUMBER_OF_RESIZING: {
      return {
        ...state,
        canDrag: false,
        numberOfResizingPhotos: state.numberOfResizingPhotos + 1,
      };
    }
    case UploaderActionKind.RESET_NUMBER_OF_RESIZING: {
      return {
        ...state,
        numberOfResizingPhotos: 0,
      };
    }
    case UploaderActionKind.REORDER_PHOTO: {
      return {
        ...state,
        photosArray: arrayMove(
          state.photosArray,
          action.oldIndex,
          action.newIndex
        ),
      };
    }
    case UploaderActionKind.INCREASE_NUMBER_OF_PHOTOS: {
      return {
        ...state,
        numberOfPhotos: state.numberOfPhotos + action.addedNumber,
      };
    }
    case UploaderActionKind.DECREASE_NUMBER_OF_PHOTOS: {
      return {
        ...state,
        numberOfPhotos: Math.max(0, state.numberOfPhotos - 1),
      };
    }
    case UploaderActionKind.ADD_IMAGE_BACK_ON_POSITION: {
      const newPhotosArray = [...state.photosArray];
      newPhotosArray.splice(action.index, 0, action.photo);
      return {
        ...state,
        numberOfPhotos: state.numberOfPhotos + 1,
        photosArray: newPhotosArray,
      };
    }
    default:
      return state;
  }
}

const EMPTY_FILE_PLACEHOLDER = new File([], "placeholder", {
  type: "image/jpeg",
});

interface UploaderState {
  canDrag: boolean;
  numberOfResizingPhotos: number;
  numberOfPhotos: number;
  photosArray: PhotoState[];
}

export interface PhotoState {
  file: File;
  resizedImageSrc: string;
  distributionSrc?: string;
  isUploaded: boolean;
}
